/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getStarterPack.defs'
export { main as default } from './getStarterPack.defs'
